import React from "react";
import { connect } from "react-redux";

import { Territory } from "@mapmycustomers/shared/types/entity";

import { getTerritory } from "@app/scene/map/store/territoryMode/selectors";
import { RootState } from "@app/store/rootReducer";

import DrawBanner from "./components/DrawBanner";
import SmartBanner from "./components/SmartBanner";

interface Props {
  onCancel?: () => void;
  territory?: Territory;
}

const EditBanner: React.FC<Props> = ({ onCancel, territory }) => {
  if (!territory?.territoryDetail?.type) {
    return null;
  }

  return territory.territoryDetail.type === "points" ? (
    <DrawBanner onCancel={onCancel} />
  ) : (
    <SmartBanner
      areaType={territory.territoryDetail.type}
      newTerritory={false}
      onCancel={onCancel}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  territory: getTerritory(state),
});

export default connect(mapStateToProps)(EditBanner);
